import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInAppLink = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "coolicons:link-sharp",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M6.41667 10.0833L4.58333 11.9167C3.8696 12.6492 3.47313 13.6334 3.47979 14.6562C3.48645 15.6789 3.89568 16.6579 4.61889 17.3811C5.3421 18.1043 6.32107 18.5136 7.34382 18.5202C8.36656 18.5269 9.35078 18.1304 10.0833 17.4167L11.9167 15.5833M15.5833 11.9167L17.4167 10.0833C18.1304 9.35078 18.5269 8.36656 18.5202 7.34382C18.5136 6.32107 18.1043 5.3421 17.3811 4.61889C16.6579 3.89568 15.6789 3.48645 14.6562 3.47979C13.6334 3.47313 12.6492 3.8696 11.9167 4.58333L10.0833 6.41667M7.33333 14.6667L14.6667 7.33333",
			strokeWidth: 1.83333,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#C1C7CD"
		})
	})
});
export default SvgInAppLink;
